import { runtime } from '../classes/runtime/Runtime';
export class RegistryItem {
    //  parent: AnyRegistryCategory | undefined;
    label_inline;
    description;
    hidden;
    type;
    key;
    constructor({ label, description, hidden } = {}) {
        // this.parent = parent;
        this.label_inline = label || '';
        this.description = description;
        this.hidden = hidden;
    }
    get label() {
        if (this.label_inline)
            return this.label_inline;
        const hidden = runtime.solidPackages.Edit.registryMetaInfo[`${this.type}s`] &&
            runtime.solidPackages.Edit.registryMetaInfo[`${this.type}s`][this.key];
        if (hidden)
            return hidden.label;
        return `${this.key[0].toUpperCase()}${this.key.slice(1)}` || 'Kein Label';
    }
    set label(l) {
        this.label_inline = l;
    }
}
